// Add your JS customizations here

jQuery(document).ready(function($) {
    // Add your custom jQuery here
    // nospam
    jQuery('.nospam').each(function(){
        var email = jQuery(this).html();
        email = email.replace("[arobase]","@");
        email = email.replace("[point]",".");
        var data = email;
        if(jQuery(this).attr("title") && jQuery(this).attr("title")!="") { data = jQuery(this).attr("title"); }
        jQuery(this).html("<a href=\"mailto:"+email+"\">"+data+"</a>");
    });
});
// Supprimer les apostrophes dans le slug des posts et pages
add_filter( 'wp_insert_post_data', 'mh_custom_slug_change', 50, 2 );
function mh_custom_slug_change( $data, $postarr ) {
    if ( !in_array( $data['post_status'], array( 'draft', 'pending', 'auto-draft' ) ) ) {
        $newSlug = str_replace("'", "-", $data['post_title']);
        $data['post_name'] = sanitize_title( $newSlug );
    }
    return $data;
}

/* Autoriser les fichiers SVG */
function wpc_mime_types($mimes) {
    $mimes['svg'] = 'image/svg+xml';
    return $mimes;
}
add_filter('upload_mimes', 'wpc_mime_types');

